/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import gql from 'graphql-tag';

export const CREDIT_FRAGMENT = gql`
  fragment OneOffCreditAllFields on OneOffCredit {
    id
    type
    userId
    productId
    productName
    voided
    currentBalance
    reason
    createdAt
    updatedAt
  }
`;

export const QUERY_CREDIT = gql`
  query OneOffCredit($id: String!) {
    oneOffCredit(id: $id) {
      ...OneOffCreditAllFields
    }
  }

  ${CREDIT_FRAGMENT}
`;

export const QUERY_CREDITS = gql`
  query OneOffCredits(
    $page: Int
    $limit: Int = 20
    $filters: TransactionsFilters
    $sortDir: SortDir = desc
  ) {
    oneOffCredits(
      filters: $filters
      sortDir: $sortDir
      page: $page
      limit: $limit
    ) {
      total
      hasMore
      items {
        ...OneOffCreditAllFields
      }
    }
  }

  ${CREDIT_FRAGMENT}
`;

export const QUERY_CREDITS_MANY = QUERY_CREDITS;

export const CREATE_CREDIT = gql`
  mutation CreateOrUpdateOneOffCredit($oneoff: CreateOrUpdateOneOffCredit!) {
    createOrUpdateOneOffCredit(oneoff: $oneoff) {
      ...OneOffCreditAllFields
    }
  }
  ${CREDIT_FRAGMENT}
`;
